import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters ([
      'isUserLoggedIn'
    ]),
    subTotal() {
      let total = 0
      this.cartProducts.forEach(item => {
        total += (this.calculateItemPrice(item) * parseInt(item.quantity))
      })
      return total.toFixed(3)
    }
  },
  methods: {
    ...mapActions ([
      'removeItemFromUserCart',
      'removeItemFromGuestCart'
    ]),
    calculateItemPrice(item) {
      const quantity = parseInt(item.quantity)
      const incoterm = item.inco_terms
      let price

      item.pricing.some(priceRange => {
        const quantityMax = String(priceRange.maxQuantity).replace(/,/g, "")

        if (quantity <= parseInt(quantityMax)) {
          if (incoterm == 'EXW')
            price = priceRange.exwPrice
          else if (incoterm == 'FOB')
            price = priceRange.fobPrice
          return parseFloat(price)
        } else {
          if (incoterm == 'EXW')
            price = item.lowestExwPrice
          else if (incoterm == 'FOB')
            price = item.lowestFobPrice
        }
      })
      return parseFloat(price)
    },
    async removeItemFromCart(item, index) {
      if (this.isUserLoggedIn) await this.removeItemFromUserCart({item, index})
      else await this.removeItemFromGuestCart(index)
      this.$emit('itemRemovedFromCart')
    }
  }
}
